import axios from 'axios';
import Api from '../Api';

class BoardmatchRepsApi extends Api {
  constructor() {
    super('boardmatch-rep', 'boardmatchrep');
  }

  async sendInvite(userInfo) {
    let res;
    const errorText = 'Failed to send invite';
    await axios.post(`/${this.endpoint}/invite`, userInfo)
      .then((response) => {
        res = response.data;
      })
      .catch((error) => {
        if (error.response) {
        // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
        // The request was made but no response was received
          console.log(error.request);
        } else {
        // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(errorText);
        res = false;
      });
    return res;
  }
}

const boardmatchRepsApi = new BoardmatchRepsApi();
export default boardmatchRepsApi;
